var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2703 0.00711002C19.7881 -0.417907 0.432097 18.2651 0.0070795 41.7296C-0.417938 65.1941 18.2651 84.5678 41.7296 84.9929C65.1941 85.4179 84.5678 66.7348 84.9928 43.2526C85.4178 19.7881 66.7348 0.414418 43.2703 0.00711002ZM41.8713 77.0238C22.8341 76.6696 7.62197 60.9085 7.97615 41.8713C8.31263 22.8341 24.0737 7.622 43.1109 7.95848C62.1659 8.31266 77.3602 24.0737 77.0238 43.1109C76.6873 62.1482 60.9085 77.3603 41.8713 77.0238Z",
    fill: "#00ADA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0613 11.5074C25.9721 11.2063 11.8226 24.86 11.5215 41.9492C11.2027 59.0208 24.8564 73.1703 41.9457 73.4891C59.0349 73.7901 73.1844 60.1364 73.4855 43.0649C73.7865 25.9757 60.1506 11.8261 43.0613 11.5074ZM42.5035 20.3406L52.3515 37.9098L43.3642 32.9088C42.8276 32.6112 42.1776 32.6112 41.6411 32.9088L32.6537 37.9098L42.5035 20.3406ZM42.5035 64.654L32.6537 47.0849L41.6411 52.0859C41.9085 52.2346 42.206 52.309 42.5017 52.309C42.7975 52.309 43.095 52.2346 43.3624 52.0859L52.3497 47.0849L42.5035 64.654ZM42.5035 48.5104L31.6939 42.4964L42.5035 36.4824L53.3113 42.4964L42.5035 48.5104Z",
    fill: "#00ADA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth2);
export default __webpack_public_path__ + "static/media/eth2.549400e7084ddedaf3fead714034eab7.svg";
export { ForwardRef as ReactComponent };